module.exports = __webpack_public_path__ + "static/media/map13.ee3bd906.webp";